import { isSameDay, startOfDay } from "date-fns";
import { RecurrenceEnum } from "web_myplann/Infrastructure/Api/Api";
import { IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS } from "web_myplann/Reminders/Config/identificationDocumentReminderOffsets";
import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import { REMINDER_TEMPLATE_LABELS } from "web_myplann/Reminders/Config/reminderTemplateLabels";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";

export type ReminderDraft = {
	id: string;
	model: ReminderFormModel;
	validTo: Date;
};

export const IDENTIFICATION_DOCUMENT_DRAFT_TEMPLATES: ReminderTemplate[] = [
	IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.oneMonthBefore,
	IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.threeMonthsBefore,
	IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.onExpiry,
].map((typeKey) => ({
	typeKey,
	labelKey: REMINDER_TEMPLATE_LABELS[typeKey] ?? null,
	recurrence: RecurrenceEnum.Once,
	isCustom: false,
}));

export const resolveReminderDrafts = (
	drafts: ReminderDraft[],
	entityConfig: ReminderEntityConfig,
	validTo: Date | null | undefined,
	today: Date,
): ReminderDraft[] => {
	if (!validTo) {
		return [];
	}

	const todayStart = startOfDay(today).getTime();

	return drafts.flatMap((draft) => {
		const date = isSameDay(draft.validTo, validTo)
			? draft.model.date
			: (entityConfig.resolveTemplateDate?.(draft.model.typeKey, validTo) ??
				null);

		if (!date || startOfDay(date).getTime() <= todayStart) {
			return [];
		}

		return [{ ...draft, model: { ...draft.model, date }, validTo }];
	});
};
